﻿import React from 'react';
import {
  EventSyntax,
  pushGaEvent,
  pushGaEventOnPageRedirect
} from '@Ensighten/Ensighten';
import Wait from '@SharedScripts/Utils/Wait';

export const track = async (event: React.MouseEvent<HTMLElement>, delayMs?: number) => {
  if (delayMs) await Wait(delayMs);

  let finalMetaData: EventSyntax = {};
  const listOfTrackingMetaData: EventSyntax[] = [];

  let currentElement = event.target as HTMLElement;

  while (currentElement) {
    try {
      const metaData = currentElement.dataset.trackingMetaData
        ? JSON.parse(currentElement.dataset.trackingMetaData) as EventSyntax
        : undefined;

      if (metaData) {
        listOfTrackingMetaData.push(metaData);
      }
    } catch (ignore) {}

    currentElement = currentElement.closest('[data-tracking-meta-data]:not(&)') as HTMLElement;
  }


  for (const metaData of listOfTrackingMetaData) {
    finalMetaData = {
      ...metaData,
      ...finalMetaData,
    };
  }

  // Find out if this click triggers a page load
  const composedPath = event.nativeEvent.composedPath();
  const aTags: HTMLLinkElement[] = composedPath.filter((element): element is HTMLLinkElement => {
    return element instanceof HTMLElement && element.tagName.toLowerCase() === 'a' && Boolean(element.getAttribute('href')) && element.getAttribute('href')?.[0] !== '#';
  });

  if (aTags.length) {
    pushGaEventOnPageRedirect(finalMetaData);
  } else {
    pushGaEvent(finalMetaData);
  }
};
